<template>
  <h2 class="title">{{ title }}</h2>
</template>

<script>
export default {
  name: 'MemberTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  padding-left: 42px;
  padding-top: 40px;
  padding-bottom: 32px;
  height: 56px;
  font-family: DiDiSans-Pro-ExtraBold;
  font-size: 40px;
  color: #0b0b0d;
  line-height: 56px;
  font-weight: normal;
}
</style>
